module.exports = __webpack_public_path__ + "static/media/homebanner.146104cb.png";